import React, { useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import { DeadLetterTab } from '../components/DeadLetterTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`messaging-tabpanel-${index}`}
    aria-labelledby={`messaging-tab-${index}`}
  >
    {value === index && <Box>{children}</Box>}
  </div>
);

const tabA11yProps = (index: number) => ({
  id: `messaging-tab-${index}`,
  'aria-controls': `messaging-tabpanel-${index}`,
});

export const MessagingPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Messaging
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 2 }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue: number) => setActiveTab(newValue)}
          aria-label="Messaging tabs"
        >
          <Tab label="Dead Letter" {...tabA11yProps(0)} />
          <Tab label="Outbox" {...tabA11yProps(1)} disabled />
        </Tabs>
      </Box>

      <TabPanel value={activeTab} index={0}>
        <DeadLetterTab />
      </TabPanel>

      <TabPanel value={activeTab} index={1}>
        <Box sx={{ p: 3 }}>
          <Typography variant="body1" color="text.secondary">
            Coming soon
          </Typography>
        </Box>
      </TabPanel>
    </Box>
  );
};
